/**
 * Mobile Navigation
 */
const mobileMenu = {
  initMenuControl: () => {
    const mainMenu = document.getElementById('mobile-navigation');
    const mainMenuToggle = document.getElementById('mobile-nav-toggle');
    const closeTriggers = document.querySelectorAll('.close-mobile-nav');

    // open menu listener
    mainMenuToggle.addEventListener('click', (e) => {
      e.preventDefault();
      mainMenu.classList.add('active');
    });

    // close click listeners
    closeTriggers.forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        mainMenu.classList.remove('active');
      });
    });

    // esc key to exit menu
    document.onkeydown = (e) => {
      e = e || window.event;
      let isEscape = false;
      if ('key' in e) {
        isEscape = e.key === 'Escape' || e.key === 'Esc';
      } else {
        isEscape = e.keyCode === 27;
      }
      if (isEscape) {
        mainMenu.classList.remove('active');
      }
    };
  },
};

export default mobileMenu;
